import { IAppBuildProgress } from '@todesktop/shared';
import { update, IGlobalState, store, selectedApp } from '../../store';
import { Modal } from 'antd';
import { callFirebaseFunction } from '../firebase';
import { history } from '../util';
import { toError } from '../util/errors';

/** Opens the create-app modal, for a team the person runs if given. */
export const goToCreateNewAppModal = (accountId?: string) => {
  update((draft) => {
    draft.uiState = 'create-new-app';
    draft.createAppAccountId = accountId ?? null;
  });
};

export const goToManageSubscriptions = () => {
  update((draft) => {
    draft.uiState = 'manage-subscriptions';
  });
};

export const goToManageAccessToken = () => {
  history.push('/settings/access-tokens');
};

export const goToManageSecurityToken = () => {
  update((draft) => {
    draft.uiState = 'manage-security-token';
  });
};

export const goToManageBilling = () => {
  update((draft) => {
    draft.uiState = 'manage-billing';
  });
};

export const goToManageAccount = () => {
  update((draft) => {
    draft.uiState = 'manage-account';
  });
};

export const goToManageUsers = () => {
  history.push('/settings/users');
};

export const goToAdminLogin = (email?: string) => {
  update((draft) => {
    draft.uiState = 'admin-login';
    draft.adminLoginEmail = email ?? null;
  });
};

export const updateUIState = (uiState: IGlobalState['uiState']) => {
  update((draft) => {
    if (uiState === 'choose-plan') {
      const state = store.getRawState();
      const { user } = state;
      const app = selectedApp(state);
      const id = app?.id;
      const subscription = app?.subscription;
      if (app && app.subscription) {
        const modal = Modal.confirm({
          title: 'Build a new version?',
          content:
            'Your users will be automatically updated to the new version the next time they open your app.',
          okText: 'Start Build',
          maskClosable: true,
          onOk: async () => {
            try {
              await createUpdateBuild(
                user?.stripeCustomerId,
                id,
                subscription?.subscriptionId,
              );
              modal.destroy();
            } catch (err) {
              Modal.error({
                title: 'Error',
                content: toError(err).message,
              });
            }
          },
        });
        return;
      } else if (user && user.stripeCustomerId) {
        console.info('Go straight to Pay Dialog');
      }
    }
    draft.uiState = uiState;
  });
};

export const removeUIState = () =>
  update((draft) => {
    draft.uiState = null;
  });

const createBuildOnExistingSubscription = callFirebaseFunction(
  'createBuildOnExistingSubscription',
);

export const initialBuildProgressState: IAppBuildProgress = {
  percent: 0,
  message: 'Queued',
  type: 'progress',
  isBuilding: true,
  shouldSkip: false,
};

function createUpdateBuild(
  stripeCustomerId: string | undefined,
  appId: string | undefined,
  subscriptionId: string | undefined,
) {
  return createBuildOnExistingSubscription({
    stripeCustomerId,
    appId: appId!,
    subscriptionId: subscriptionId!,
  });
}
